"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeURI = exports.encodeURI = void 0;
const base62str_1 = __importDefault(require("base62str"));
/**
 * Note: we have to use base62 to encode/decode instead of encodeURIComponent/decodeURIComponent
 * because encodeURIComponent/decodeURIComponent and React Router don't play well together.
 *
 * @example
 * encodeURIComponent('test#%%-test/testbranch') => 'test%25%%-test/testbranch'
 *
 * Also:
 * @see https://github.com/remix-run/react-router/issues/7987
 */
const IDENTIFIER = 'b:';
const base62string = base62str_1.default.createInstance();
/**
 *
 * @param value - string value to encode
 * @returns encoded value
 */
const encodeURI = (value) => {
    /* We cannot probably encode the value if it includes a '%' (see comment above) */
    if (value.includes('%')) {
        return IDENTIFIER + base62string.encodeStr(value);
    }
    return encodeURIComponent(value);
};
exports.encodeURI = encodeURI;
/**
 *
 * @param value - string value to encode
 * @returns encoded value
 */
const decodeURI = (value) => {
    if (value.startsWith(IDENTIFIER)) {
        const b62Value = value.slice(2);
        return base62string.decodeStr(b62Value);
    }
    return decodeURIComponent(value);
};
exports.decodeURI = decodeURI;
//# sourceMappingURL=uriEncodeDecode.js.map